import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { LoyaltyCurrencyService } from '@rd/core/services/loyalty-currency/loyalty-currency.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { LoyaltyProgram } from '@rd/types';
import { Promocode } from '@rd/types/promocode.type';
import {
  LoyaltyProgramNameAttributes,
  TransferConnectV2SettingService,
} from '../../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { EnrichedTransferConnectV2CheckoutFormData } from '../../types';

@Component({
  selector: 'rd-tcv2-review-breakdown',
  templateUrl: './review-breakdown.component.html',
  styleUrls: ['./review-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2ReviewBreakdownComponent implements OnInit, OnChanges {
  @HostBinding('class.rd-tcv2-review-breakdown') componentClass = true;
  @Input() formData: EnrichedTransferConnectV2CheckoutFormData;
  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() promocode: Promocode | null;
  loyaltyProgramNameAttribute: LoyaltyProgramNameAttributes;

  hasDiscount = false;

  constructor(
    private loyaltyCurrencyService: LoyaltyCurrencyService,
    private numberService: NumberService,
    private transferConnectV2SettingService: TransferConnectV2SettingService,
  ) {}

  ngOnChanges(): void {
    this.hasDiscount =
      !!this.promocode &&
      this.formData.sourceAmountPaid != null &&
      this.formData.sourceAmountPaid < this.formData.sourceAmount;
  }

  ngOnInit(): void {
    this.loyaltyProgramNameAttribute =
      this.transferConnectV2SettingService.loyaltyProgramNameAttribute;
  }

  sourceAmountString(amount: number): string {
    const sourceAmountParams = this.sourceAmountParams(amount);

    return `${sourceAmountParams.points_amount} ${sourceAmountParams.currency}`;
  }

  sourceAmountParams(amount: number): {
    points_amount: string;
    currency: string;
  } {
    return {
      points_amount: this.numberService.formatNumber(amount),
      currency:
        // @ts-ignore
        this.loyaltyCurrencyService.loyaltyCurrencySelected[
          this.loyaltyProgramNameAttribute
        ],
    };
  }

  formattedDestinationAmount(): string {
    return `${this.numberService.formatNumber(
      this.formData.targetAmount,
    )} ${this.transferConnectV2SettingService.formattedDestinationAmountName(
      this.loyaltyProgram,
    )}`;
  }
}
